import type { GridCombinedList, GridIdList, GridNameList } from './types';

/**
 * Creates a combined grid map that includes both grid codes and IDs.
 * This allows for more robust grid resolution by either code or ID.
 *
 * @param nameList - A GridNameList mapping grid codes to arrays of GridInterface.
 * @param idList - A GridIdList mapping grid IDs to arrays of GridInterface.
 * @returns A combined GridIdList that maps both grid codes and IDs to their respective GridInterface arrays.
 */
export function createCombinedGridMap(
  nameList: GridNameList,
  idList: GridIdList,
): GridCombinedList {
  const combinedMap = { ...idList };

  Object.entries(nameList).forEach(([code, gridInterfaces]) => {
    // Only add if the code doesn't already exist in the combined map
    combinedMap[code] ??= gridInterfaces;
  });

  return combinedMap;
}
